import { Box, Grid } from "@mui/material";
import { ReactComponent as AddUser } from "assets/AddUser.svg";
import { ReactComponent as ArrowDown } from "assets/ArrowDown.svg";
import { ReactComponent as ArrowUp } from "assets/ArrowUp.svg";
import { getAllBreakupLists } from "components/features/MyLists/MyLists";
import { setProgressInfoSummary } from "components/features/Progress/Progress.slice";
import { cloneDeep, isNull, uniqueId } from "lodash";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAppDispatch } from "redux/hooks";
import { tokens } from "styles/Tokens";
import { getTableColor, getUserNameByHltId, noDataFound } from "utils/CommonFunctions";
import { getUIFormatDate } from "utils/DateHelper";
import { getUserNameWithConditionalCheck } from "utils/SharedUtils";
import CheckBox from "./Checkbox";
import "./MobileTableForSCList.scss";
import Typography from "./Typography";

const MobileCommonTableForSCList = (props: any) => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { setUnCheckedMappings, unCheckedMappings } = props;
  const [isRowOpen, setIsRowOpen] = useState<any>([]);

  const openSelectedRow = (row: any, index: any) => {
    // Create a deep clone of the current `isRowOpen` state to avoid mutating state directly
    const clonedIsRowOpen = cloneDeep(isRowOpen);
    // Find if an entry with the given index already exists in the cloned state
    const item = clonedIsRowOpen?.find((item: any) => item.key === index);

    if (item) {
      // If found, toggle its `isOpen` state
      item.isOpen = !item.isOpen; // Mutating the object directly inside cloned array
    } else {
      // If not found, add a new entry with `isOpen` set to `true`
      clonedIsRowOpen.push({ key: index, isOpen: true });
    }

    // Update the state with the modified cloned array
    setIsRowOpen(clonedIsRowOpen);
    if (row?.inncodeMappingIds?.length) props.fetchIndividualProperty(row, index);
    props.setId(row);
  };

  const renderRow = (history: any, row: any, historyIndex: number, index: number) => {
    const userInfo = getUserNameByHltId(props.allTeamMember, history.hltId);
    const historyLength = row?.history?.length - 1;
    const userClickable =
      row?.implementedPlansCount > 0 && (history?.completedPlansCount > 0 || history?.activePlansCount > 0);
    return (
      <div className="history-container">
        <div className="grid-2fr-table history-wrapper">
          <div className="header-value-wrapper user-checkbox">
            <CheckBox
              className="value-checked"
              onChange={(e: any) => {
                props.handleChildCheckbox(e, history, historyIndex, index, row);
              }}
              checked={history.isChecked}
            />
            <Typography variant="body2" color={tokens.Text.General.PrimaryHeadline}>
              User
            </Typography>
          </div>
          <div className="header-value-wrapper">
            <div className="display-username">
              <Typography
                color={tokens.Text.General.Color}
                variant="body2"
                className={userClickable ? "cursor-pointer no-wrap-white-space" : " no-wrap-white-space"}
                onClick={() => {
                  if (userClickable) {
                    const userData = {
                      ...history,
                      displayName: getUserNameWithConditionalCheck(
                        userInfo?.displayName,
                        userInfo?.firstName,
                        userInfo?.lastName
                      )
                    };
                    navigate(
                      `/progressInfo/users/${props.selectedList?.id}?inncode=${row?.inncode}&users=${history.hltId}`
                    );
                    dispatch(setProgressInfoSummary(userData));
                  }
                }}
              >
                {getUserNameWithConditionalCheck(userInfo?.displayName, userInfo?.firstName, userInfo?.lastName)}
              </Typography>
            </div>
          </div>
          <div className="header-value-wrapper">
            <Typography variant="body2" color={tokens.Text.General.PrimaryHeadline}>
              Last Assignment
            </Typography>
          </div>
          <div className="header-value-wrapper">
            {" "}
            <Typography variant="body2" color={tokens.Text.General.PrimaryHeadline}>
              {isNull(history.lastAssignmentDateTime) ? "-" : getUIFormatDate(history.lastAssignmentDateTime)}
            </Typography>
          </div>

          <div className="header-value-wrapper">
            <Typography variant="body2" color={tokens.Text.General.PrimaryHeadline}>
              Active Plans*
            </Typography>
          </div>
          <div className="header-value-wrapper">
            <Typography variant="body2" color={tokens.Text.General.PrimaryHeadline}>
              {history.activePlansCount || 0}
            </Typography>
          </div>

          <div className="header-value-wrapper">
            <Typography variant="body2" color={tokens.Text.General.PrimaryHeadline}>
              Completed Plans
            </Typography>
          </div>
          <div className="header-value-wrapper">
            <Typography variant="body2" color={tokens.Text.General.PrimaryHeadline}>
              {history.completedPlansCount || "0"}
            </Typography>
          </div>

          <div className="header-value-wrapper">
            <Typography variant="body2" color={tokens.Text.General.PrimaryHeadline}>
              Engagement
            </Typography>
          </div>
          <div className="header-value-wrapper">
            <Typography variant="body2" color={tokens.Text.General.PrimaryHeadline}>
              {history.engagement || "-"}
            </Typography>
          </div>
          {historyLength === historyIndex && (
            <div className="header-value-wrapper">
              <div className="add-member">
                <div
                  className="member-wrapper"
                  onClick={() => props.handleUserVisible({ isVisible: true, row: row, index: index })}
                >
                  <Typography variant="label" showBold color={tokens.Text.General.Color}>
                    <div className="add-user">
                      <AddUser /> Add Team Member
                    </div>
                  </Typography>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    );
  };

  const renderRowEmpty = (row: any, index: any) => {
    return (
      <div className="history-container">
        <div className="grid-2fr-table history-wrapper">
          <div className="header-value-wrapper">
            <div className="add-member">
              <div className="member-wrapper">
                <Typography variant="label" showBold color={tokens.Text.General.Color}>
                  <div
                    className="add-user"
                    onClick={() => props.handleUserVisible({ isVisible: true, row: row, index: index })}
                  >
                    <AddUser /> Add Team Member
                  </div>
                </Typography>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };
  const showRowInncode = (row: any) => {
    let implementedPlansCountStatusBreakUp = getAllBreakupLists(row.implementedPlansCountStatusBreakUp);
    const renderList = () => {
      return (
        <Grid marginTop={"10px"}>
          <Box marginBottom={"-4px"}>
            <Typography variant="body2" color={tokens.Text.General.PrimaryHeadline} showBold>
              {row?.implementedPlansCount}
            </Typography>
          </Box>
          {implementedPlansCountStatusBreakUp?.map((item: any) => {
            return (
              <Grid key={uniqueId("TOOLTIP_ITEM_")} sx={{ color: getTableColor(item?.name), whiteSpace: "nowrap" }}>
                <Typography variant={"label"} component={"span"} showBold>
                  {item.value < 10 ? "0" : ""}
                  {`${item.value ?? ""}  `}
                </Typography>
                <Typography variant={"label"} component={"span"}>
                  {item?.name} {item?.isShowStar > 0 ? "*" : ""}
                </Typography>
              </Grid>
            );
          })}
        </Grid>
      );
    };
    return (
      <div className="history-container">
        <div className="grid-2fr-table history-wrapper inncode-wrapper">
          <div className="header-value-wrapper">
            <Typography variant="body2" color={tokens.Text.General.PrimaryHeadline}>
              Inncode
            </Typography>
          </div>
          <div className="header-value-wrapper">
            {" "}
            <Typography variant="body2" color={tokens.Text.General.PrimaryHeadline}>
              {row?.inncode || "-"}
            </Typography>
          </div>
          <div className="header-value-wrapper">
            <Typography variant="body2" color={tokens.Text.General.PrimaryHeadline}>
              Brand
            </Typography>
          </div>
          <div className="header-value-wrapper">
            {" "}
            <Typography variant="body2" color={tokens.Text.General.PrimaryHeadline}>
              {row?.brandName || "-"}
            </Typography>
          </div>
          <div className="header-value-wrapper">
            <Typography variant="body2" color={tokens.Text.General.PrimaryHeadline}>
              Plans
            </Typography>
          </div>
          <div className="header-value-wrapper plans-breakup">
            {implementedPlansCountStatusBreakUp?.length ? (
              renderList()
            ) : (
              <div className="header-value-wrapper">
                <Typography variant="body2" color={tokens.Text.General.PrimaryHeadline}>
                  {"0"}
                </Typography>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className="common-mobile-table">
      {props?.data?.rows?.length ? (
        <div className="common-mobile-table-container ">
          <div className="content-wrapper bottom-border">
            <div className="content-header-container">
              <div className="icon-name-wrapper">
                <div className="up-down-icon visibility-hidden">
                  <ArrowUp />
                </div>
                <div className="value-with-checkbox">
                  <CheckBox
                    className="value-checked"
                    disabled={props.totalRecords === 0}
                    onChange={props.handleSelectedAll}
                    checked={props.selectAllProperties}
                  />
                  <div className="ellipse-two">
                    <Typography color={tokens.Text.General.PrimaryHeadline} variant="body2">
                      Properties
                    </Typography>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {props?.data?.extraData.map((row: any, index: any) => {
            // Find if the row with the given index is open
            const isRowExpanded = isRowOpen?.find((item: any) => item.key === index)?.isOpen;
            const lastIndex = props?.data?.rows?.[index]?.data?.length - 1;
            const bookmarked = props?.data?.rows?.[index]?.data[lastIndex];
            return (
              <>
                <div className={`content-wrapper ${isRowExpanded ? "section-heading-open" : ""} `}>
                  <div className="content-header-container">
                    <div className="icon-name-wrapper">
                      <div
                        className="up-down-icon"
                        onClick={() => {
                          openSelectedRow(row, index);
                        }}
                      >
                        {isRowExpanded ? <ArrowUp /> : <ArrowDown />}
                      </div>
                      <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                        <CheckBox
                          className="value-checked"
                          checked={row.isChecked}
                          disabled={!row.inncodeusers?.length}
                          onChange={(e: any) => {
                            props.handleParentCheckbox(e, row, index);
                          }}
                        />
                        <div
                          className="ellipse-two"
                          onClick={() => navigate(`/property/${row.inncode}?parentTab=Property+Plans`)}
                        >
                          <Typography variant="body2" color={tokens.Text.General.PrimaryHeadline} showBold>
                            {row.propertyName}
                          </Typography>
                        </div>
                      </div>
                    </div>
                    <div className="action-main">{bookmarked?.content}</div>
                  </div>
                </div>
                {isRowExpanded && (
                  <>
                    <div>{showRowInncode(row)}</div>
                    {row.history.length ? (
                      row.history.map((history: any, historyIndex: number) => {
                        return <div>{renderRow(history, row, historyIndex, index)}</div>;
                      })
                    ) : (
                      <div>{renderRowEmpty(row, index)}</div>
                    )}
                  </>
                )}
              </>
            );
          })}
        </div>
      ) : (
        <div className="horizontal-center">{noDataFound(props?.data?.headers?.length, "No Results")}</div>
      )}
    </div>
  );
};

export default MobileCommonTableForSCList;
